module.exports = __webpack_public_path__ + "static/media/arrows-down-to-people.fb5542f5.svg";